// shared-package/queries/contests.ts
import { useMutation } from "@tanstack/react-query";
export const createContactRequestsQueries = (requests) => ({
    useCreateContactRequest: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createContactRequest,
    }),
});
//# sourceMappingURL=index.js.map